import { z } from 'zod';
export const SignupCheckRequestSchema = z.object({
    email: z.string().email(),
});
export const SignupCheckResponseSchema = z.object({
    allowed: z.boolean(),
    reason: z.string().optional(),
});
export const AbuseEventSchema = z.object({
    type: z.enum(['disposable_email', 'ip_limit', 'generation_throttle', 'prompt_dedup']),
    userId: z.string().optional(),
    ip: z.string().optional(),
    promptHash: z.string().optional(),
    timestamp: z.string(),
});
//# sourceMappingURL=abuse.js.map